import { useLanguage } from "../../hooks/useLanguage";
import { imageMap } from "../image";
import "./experience-style.scss";
import { SpotlightCard } from "../ui/SpotlightCard"; // Importamos el nuevo componente

import ENSO from "../../images/enso-learning.webp"
import KUEPA from "../../images/kuepa.webp"
import DAPMARKET from "../../images/dapmarket.webp"
import VALEMAS from "../../images/valemas.webp"

export const Experience = () => {
  const { translations: t } = useLanguage();
  const EXPERIENCE = t.experience.jobs;

  const imgJobs = (id: number) => {
    switch (id) {
      case 0: return ENSO;
      case 1: return KUEPA;
      case 2: return DAPMARKET;
      case 3: return VALEMAS;
      default: return undefined;
    }
  };

  const urlJob = (id: number) => {
    return EXPERIENCE[id]?.urlJob || "#";
  };
  
  return (
    <div className="experience_container">
      <section className="skills_section">
        <h2 className="section_title">
          <span className="accent_line"></span>
          {t.experience.title1}
        </h2>
        <div className="skills_grid">
          {imageMap.map((item, index) => (
            // Usamos SpotlightCard en lugar de un div normal
            <SpotlightCard key={index} className="skill_card_wrapper">
                <div className="skill_content">
                  <div className="icon_wrapper">
                    <img src={item.image} alt={item.text} className="skill_icon" style={{ borderRadius: item.borderRadius }} />
                  </div>
                  <p className="skill_name">{item.text}</p>
                </div>
            </SpotlightCard>
          ))}
        </div>
      </section>
  
      <section className="timeline_section">
        <h2 className="section_title">
          <span className="accent_line"></span>
          {t.experience.title2}
        </h2>
        
        <div className="timeline">
          {EXPERIENCE.map((job, id) => (
            <div key={id} className="timeline_item">
              <div className="timeline_dot"></div>
              {/* Envolvemos el contenido del timeline también */}
              <SpotlightCard className="timeline_content">
                <div className="job_header">
                  <div className="company_info">
                    <a href={urlJob(id)} target="_blank" rel="noopener noreferrer" className="company_logo_link">
                      <img className="company_logo" src={imgJobs(id)} alt={job.titleJob} />
                    </a>
                    <div className="title_wrapper">
                      <a href={urlJob(id)} target="_blank" rel="noopener noreferrer" className="job_title">
                        {job.titleJob}
                      </a>
                      <span className="job_date">{job.dateJob}</span>
                    </div>
                  </div>
                </div>
                
                <div className="job_description">
                  <span dangerouslySetInnerHTML={{ __html: job.textJob }} />
                </div>
              </SpotlightCard>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
